import React from 'react';
import moment from 'moment';
import { PluginsTableProps } from './types';
import { styles } from './styles';
import { Table, Column } from '@v2/components';
import { MissionControlPlugin } from '@v2/types';

const formatReleaseDate = (releaseDate: string): string =>
  moment.utc(releaseDate).local().format('M/D/YYYY LT');

const columns: Column<MissionControlPlugin>[] = [
  {
    key: 'name',
    header: 'Name',
    sortKey: 'name',
    render: (row) => (
      <div className={styles.cellBlock}>
        <span className={row.isInactive ? styles.inactive : styles.name}>
          {row.name}
        </span>
        <span className={styles.uid}>{row.id}</span>
      </div>
    ),
  },
  {
    key: 'defaultVersion',
    header: 'Default Version',
    render: (row) => {
      const v = row.defaultVersion;
      if (!v) return <span className={styles.version}>-</span>;
      return (
        <div className={styles.cellBlock}>
          <span className={styles.version}>{v.version}</span>
          <span className={styles.releaseDate}>{formatReleaseDate(v.releaseDate)}</span>
        </div>
      );
    },
  },
  {
    key: 'defaultVersionDescription',
    header: 'Default Version Description',
    render: (row) => (
      <span className={styles.version}>
        {row.defaultVersion?.description ?? '-'}
      </span>
    ),
  },
];

const PluginsTable: React.FC<PluginsTableProps> = ({
  plugins,
  loading,
  error,
  onSelectPlugin,
  selectedPluginId,
  sortConfig,
  onSortChange,
  search,
  onSearchChange,
  searchPlaceholder,
  filterSlot,
}) => (
  <Table<MissionControlPlugin>
    columns={columns}
    data={plugins}
    keyExtractor={(plugin) => plugin.id}
    loading={loading}
    error={error}
    emptyMessage="No plugins found."
    onRowClick={onSelectPlugin}
    selectedKeys={selectedPluginId ? [selectedPluginId] : []}
    sortConfig={sortConfig ?? null}
    onSortChange={onSortChange}
    search={search}
    onSearchChange={onSearchChange}
    searchPlaceholder={searchPlaceholder}
    filterSlot={filterSlot}
  />
);

export default PluginsTable;
